import Component from './instantwin_message_table.vue'
export default Component
